export const Fantasia2000 = () => {
    let datas = require.context('../../assets/images/origins/fantasia-2000', false);
    return datas.keys().map(image => datas(image));
}